import * as ActionTypes from '../actionTypes';
import Config from '../../Config';
import { getCurrentUserInfo } from '../../Lib/Utils';

const initialState = {
    isLoading: false,
    avatar: '/img/avatar.svg',
    data: {
        user: {},
        company: {},
    },
    userList: [],
    inviteList: [],
    referral: {},
};

export default function reducer(state = initialState, action) {
    let object;
    let avatar;
    switch (action.type) {
        case ActionTypes.USER_LOGGING:
            object = {
                isLoading: true,
            };
            return { ...state, ...object };
        case ActionTypes.COMPLETE_GET_USER_DETAILS:
            const loggedUser = getCurrentUserInfo() || { sub: '' };
            const userId = loggedUser.sub;
            object = {};
            object.data = action.payload;
            if (action.payload.user.Avatar) {
                avatar = `${Config.bucketUrl}${userId}/${action.payload.user.Avatar}`;
                avatar = `${avatar}?t=${Date.now()}`;
                object.avatar = avatar;
                localStorage.setItem('PT-avatar', avatar);
            }
            return { ...state, ...object };
        case ActionTypes.COMPLETE_UPDATE_AUTOPILOT:
            object = { ...{}, ...state };
            object.data.company.AutopilotEmail = action.payload;
            return { ...state, ...object };
        case ActionTypes.COMPLETE_GET_USER_LIST:
            object = {
                userList: action.payload,
            };
            return { ...state, ...object };
        case ActionTypes.COMPLETE_GET_INVITE_LIST:
            let inviteList = action.payload;
            inviteList = inviteList.map((item) => {
                item.Data = typeof item.Data === 'object' ? item.Data : JSON.parse(item.Data);
                return item;
            });
            object = {
                inviteList,
            };
            return { ...state, ...object };
        case ActionTypes.UPDATE_REFERRAL_STATUS:
            return { ...state, referral: action.payload };
        default:
            if (localStorage.getItem('PT-avatar')) {
                return { ...state, ...{ avatar: localStorage.getItem('PT-avatar') } };
            }
            return state;
    }
}
